import moment from 'moment';

import { Link, useLocation } from 'react-router-dom';
import { FiDatabase } from 'react-icons/fi';
import { withTranslation } from 'react-i18next';

const DbCard = ({ id, schema = {}, updated_at, t }) => {
  const location = useLocation();

  return (
    <div className="col-md-4 mb-4">
      <Link className="card shadow-sm link-clean  rounded-3 border-0" to={{ pathname: `/databases/${id}`, state: { background: location } }}>
        <div className="card-body bg-white rounded-3 p-3">
          <div className="d-flex align-items-center">
            <div>
              <FiDatabase size={44} color="#ccc" />
            </div>

            <div className="ms-2" style={{ maxWidth: '80%' }} title={schema.title}>
              <h5 className="fw-normal mt-0 mb-0 text-truncate">{schema.title}</h5>
              <small>
                {t('keys.updated_at')} {moment(updated_at).format('DD/MM/YYYY HH:mm')}
              </small>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default withTranslation()(DbCard);
